import { FormatTimeValues } from '../../global/types';
import { trunc, getFraction } from '../math';

/**
 * Time formatting logic from BR2
 * https://schneider.atlassian.net/wiki/spaces/PESV3/pages/2115274299/APC+Runtime+graph+and+chart
 */
export function formatTime(
  totalMinutes: number,
  formatter: FormatTimeValues = { hour: 'h', min: 'm', sec: 's' },
): string {
  if (totalMinutes <= 0) {
    return '';
  }

  if (totalMinutes < 30) {
    const minutes = trunc(totalMinutes);
    const seconds = trunc(getFraction(totalMinutes) * 60);
    const minutesText = minutes > 0 ? `${minutes}\u00A0${formatter.min}` : '';
    const secondsText = seconds > 0 ? `${seconds}\u00A0${formatter.sec}` : '';
    return `${minutesText}${
      secondsText.length && minutesText.length ? ' ' : ''
    }${secondsText}`;
  }
  if (totalMinutes < 60) {
    const minutes = trunc(totalMinutes);
    return `${minutes}\u00A0${formatter.min}`;
  }

  const hours = trunc(totalMinutes / 60);
  const minutes = trunc(totalMinutes % 60);
  const hoursText = `${hours}\u00A0${formatter.hour}`;
  const minutesText = minutes > 0 ? `${minutes}\u00A0${formatter.min}` : '';
  return `${hoursText}${minutesText.length ? ' ' : ''}${minutesText}`;
}
